import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

import Constraint from 'js/components/Constraint';

const Code = animated(styled.div`
  font-weight: 700;
  font-size: 32px;
  color: #888;
`);

const Message = animated(styled.div`
  margin-top: 1rem;
  font-weight: 700;
`);

const Container = styled.div`
  margin: 5rem 0 2rem;
  text-align: center;
`;

const Img = styled.img`
  width: auto;
  height: '350px
`;

const Div1 = styled.div`
  font-size: 25px;
  padding-top: 35px; line-height: 30px; font-weight: bold;
`;

const Div2 = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

export default ({ error }) => (
  <Constraint>
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
      {animation => (
        <Container>
          <Code style={animation}>
            {error.status === 404 ? (
              <>
                <div id="wrap" style={{marginBottom:'0px', textAlign:'center'}}>
                  <div style={{width:'90%',paddingLeft:'0.625rem',paddingRight:'0.625rem',marginRight:'auto',marginLeft:'auto',overflow:'visible',position:'relative',textAlign:'left'}}>
                    <div style={{margin:'50px auto', padding:'18px 20px 30px 20px',textAlign:'center',borderRadius:'10px'}}>
                      <Img className="404_image" src="/images/v2/page-not-found.svg" />
                    </div>
                  </div>
                </div>
              </>
            ) :
              error.status === 401 ? (
                this.login_button.current.click()
              ) : error.status
            }
          </Code>
          <Message style={animation}>{error.error}</Message>
          <div>
            <p>
              <img src="/images/icons/icon-left.svg" alt="go back" />
              <a href="/">back to home </a>
            </p>
          </div>
        </Container>
      )}
    </Spring>
  </Constraint>
);
